import { useEffect } from 'react';

import i18n from '../providers/Locale';

const useBaseHead = () => {
	useEffect(() => {
		document.title = i18n('reservation') ?? 'Choice booking';
	}, []);
};

export default useBaseHead;
